(() => {
  function initialise(root) {
    if (root.dataset.mlReady) return;
    root.dataset.mlReady = 'true';
    const variants = JSON.parse(root.querySelector('[data-ml-variants]').textContent);
    const hero = root.querySelector('[data-ml-hero]');
    const select = root.querySelector('[data-ml-variant]');
    const price = root.querySelector('[data-ml-price]');
    const compare = root.querySelector('[data-ml-compare]');
    const add = root.querySelector('[data-ml-add]');
    const status = root.querySelector('[data-ml-status]');
    const quantity = root.querySelector('[data-ml-quantity]');
    root.querySelectorAll('[data-ml-image]').forEach(button => {
      button.addEventListener('click', () => {
        if (!hero) return;
        hero.src = button.dataset.mlImage;
        hero.alt = button.dataset.mlAlt;
      });
    });
    select?.addEventListener('change', () => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant) return;
      price.textContent = variant.price.replace(/<[^>]*>/g, '');
      compare.textContent = (variant.compare || '').replace(/<[^>]*>/g, '');
      compare.hidden = !variant.compare;
      add.disabled = !variant.available;
      add.textContent = variant.available ? 'Add to bag' : 'Sold out';
      status.textContent = variant.available ? '' : 'This option is currently unavailable. Choose another option above.';
      quantity.min = variant.min;
      quantity.step = variant.step;
      quantity.value = variant.min;
      if (variant.max) quantity.max = variant.max;
      else quantity.removeAttribute('max');
      if (hero && variant.image) {
        hero.src = variant.image;
        hero.alt = variant.alt;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  }
  const init = () => document.querySelectorAll('[data-ml-product]').forEach(initialise);
  init();
  document.addEventListener('shopify:section:load', init);
})();
